import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Magnifier from 'react-magnifier';
import ImageDemo from '../../../../images/image-demo.jpg';
import IconChevronDown from '../../../../images/icon-chevron-down.svg';

import './demo.scss';
const Demo = () => {
	return (
		<div id='demo'>
			<Row>
				<Col md={6} xl={5} className='text-side'>
					<h2>Demotermin</h2>
					<p>
						Gerne stellen wir Ihnen unsere Software in einem 30-minütigen
						Telefonat genauer vor und beantworten Ihre offenen Fragen.
					</p>
					<a href='mailto:info@sustragil.com?subject=Anfrage für Demotermin'>
						Demotermin vereinbaren
						<img src={IconChevronDown} />
					</a>
				</Col>
				<Col md={6} xl={7} className='magnifier-side'>
					<Magnifier className='magnifier' src={ImageDemo} width='100%' />
				</Col>
			</Row>
		</div>
	);
};

export default Demo;
